import React from "react";
import { marked } from "marked";
import PageHero from "../../components/PageHero";

export default function PageDefault({ siteContent }) {
  const { title, headContent, bodyContent, image } = siteContent;

  return (
    <>
      <PageHero
        title={title}
        subtitle={headContent}
        img={image?.url}
      />

      <main className="container main">
        <section className="section__body" dangerouslySetInnerHTML={{ __html: marked(bodyContent) }} />
      </main>
    </>
  );
}